import { render } from "./PregList.vue?vue&type=template&id=63227f33"
import script from "./PregList.vue?vue&type=script&lang=js"
export * from "./PregList.vue?vue&type=script&lang=js"

import "./PregList.vue?vue&type=style&index=0&id=63227f33&lang=css"
import "./PregList.vue?vue&type=style&index=1&id=63227f33&lang=css"
import "./PregList.vue?vue&type=style&index=2&id=63227f33&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__